export default {
  FAILED: 'FAILED',
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  SUCCESSED: 'SUCCESSED',
};
